import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Card } from '@lightspeed/flame/Card';
import { Flex, themeGet } from '@lightspeed/flame/Core';
import { Heading1, Text } from '@lightspeed/flame/Text';

export const BoldHeader = styled(Heading1)`
  color: ${themeGet('colors.black')};
  font-size: 21px !important;
  font-weight: 700;
  margin-bottom: 6px;
  line-height: 36px;
`;

export const UppercaseSubHeading = styled(Text)`
  font-weight: 700;
  font-size: ${themeGet('space.2')};
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${themeGet('colors.textHeading')};
`;

export const StyledDescription = styled(Text)`
  color: ${themeGet('colors.textDimmed')} !important;
  font-size: 14px;
`;

export const StyledButton = styled(Button)`
  font-size: 14px !important;
  color: #fff !important;
  border-color: #1844cc !important;
  margin-top: 18px !important;
`;

export const IconWrapper = styled(Flex)`
  height: 16px;
  width: 17px;
  border-radius: 100%;
  background-color: #059118;
  align-items: center;
  justify-content: center;
`;

export const StyledFlex = styled(Flex)`
  width: 246px;
  flex: 0 0 auto;
  justify-content: center;

  @media screen and (max-width: 699px) {
    display: none;
  }
`;

export const StyledCard = styled(Card)`
  padding-right: 36px;
  padding-top: 32px;
  padding-bottom: 32px;
  margin-top: 24px;

  @media screen and (max-width: 1200px) {
    padding-right: 24px;
  }

  @media screen and (max-width: 700px) {
    padding-left: 24px;
    padding-top: 24px;
    padding-bottom: 24px;
  }
`;

export const StyledInvoiceCard = styled(Card)`
  margin-bottom: 24px;
  padding: 60px;
`;
